import { Map, Record } from 'immutable';

import type { ObjectEntityNative, ObjectsState, TransformedObject } from './types';

type CreateObjectEntityProps = TransformedObject & {
  matchIds?: Set<number>;
};

export const initialState = Record<ObjectsState>({
  byId: Map(),
}, 'ObjectsState');

const ObjectEntity = Record<ObjectEntityNative>(
  {
    id: 0,
    type: undefined,
    name: '',
    matchIds: new Set(),
    icon: '',
  },
  'ObjectEntity',
);

export const createObjectEntity = (data: CreateObjectEntityProps) => {
  const matchIds = 'matchIds' in data ? data.matchIds : new Set<number>();

  return ObjectEntity({
    ...data,
    matchIds,
  });
};
